<template>
  <div class="row pt5 pb5">
    <div class="col">
      <Button label="Imprimer" v-on:click="imprimer" />
    </div>
    <div class="col">
      <Button label="Fermer" v-on:click="fermer"/>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ButtonBar',
  emits: ['imprimer', 'fermer'],
  methods: {
    imprimer() {
      this.$emit('imprimer')
    },
    fermer() {
      this.$emit('fermer');
    },
  }
}
</script>